import {
  TextButton,
  useIcon,
  ModalContext,
  type ModalContextType,
} from "@SeemplicityDev/shared";
import "./AddAutomationCard.scss";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AddAutomationCardEmpty = () => {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext) as ModalContextType;
  const { getSvg } = useIcon();

  return (
    <div
      className={`add-automation-card is-empty`}
      data-testid="add-automation-card"
    >
      <img src={getSvg("add-automation-empty")} alt="No use cases" />
      <div className="card-description">
        Ticketing Automation is only possible if you connect it to the Ticketing
        System you're already using
      </div>
      <Link to="/settings/integrations/ticketingSystems">
        <TextButton
          buttonStyle={"primary"}
          label={t("Connect your first Ticketing System")}
          onClick={closeModal}
          data-analytics-event="user_click"
          data-analytics-props={`{"name": "ticketing_system_empty_state_connect_btn", "container": "add_automation_modal"}`}
        />
      </Link>
    </div>
  );
};

export default AddAutomationCardEmpty;
